<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="titulo">
        <h3>{{ titulos[boletinParam] }}</h3><img src="./assets/img/book.png" />
    </div>
    <div class="linea-titulo"></div>
    <div class="borde-filtro">
        <p class="date-picker-label">Seleccione uno o varios días:</p>
        <div *ngIf="ready" style="width: 100%;">
            <mat-form-field class="date-picker">
                <mat-label>Seleccione un rango</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate placeholder="Fecha desde" (dateChange)="setDates('from', $event)"
                        [min]="rangoFechasTope[boletinParam]['min']" [max]="rangoFechasTope[boletinParam]['max']">
                    <input matEndDate placeholder="Fecha hasta" (dateChange)="setDates('to', $event)"
                        [min]="rangoFechasTope[boletinParam]['min']" [max]="rangoFechasTope[boletinParam]['max']">
                </mat-date-range-input>
                <mat-hint style="font-size: small; color: #585858">DD/MM/AAAA - DD/MM/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
    </div>
    <div>
        <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="fecha">
                <th mat-header-cell *matHeaderCellDef> <span>{{tituloColumnaFecha}}</span> </th>
                <td mat-cell *matCellDef="let boletin"> {{ boletin.fechaBoletin | date: 'dd/MM/yyyy' : 'UTC' }} </td>
            </ng-container>
            <ng-container matColumnDef="boletin">
                <th mat-header-cell *matHeaderCellDef>
                    <span>{{ cabeceras[boletinParam] }}</span>
                </th>
                <td mat-cell *matCellDef="let boletin"> 
                    <a *ngIf="boletin.rutaReporte !== 'null'" href="{{ boletin.rutaReporte }}"
                        target="_blank">
                        {{ boletin.descripcion !== boletin.rutaReporte ? boletin.descripcion : boletin.fechaBoletin
                        | date: 'dd/MM/yyyy' : 'UTC' }}
                    </a>
                </td>
            </ng-container>
            <ng-container matColumnDef="adicional">
                <th mat-header-cell *matHeaderCellDef>
                    <span>{{ cabecerasAdicionales[boletinParam] }}</span>
                </th>
                <td mat-cell *matCellDef="let boletin"> 
                    <a class="break-word" href="{{ boletin.segundaRutaReporte }}" target="_blank">
                        Documento
                    </a>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns[boletinParam];" class="cabecera-tabla"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns[boletinParam]; let i = index" [ngClass]="{'interlineado': i%2===0 }"></tr>
        </table>
        <mat-paginator [length]="dataSource.data.length" [pageSize]="15" [pageSizeOptions]="[15, 50, 100]" 
            aria-label="Seleccionar página">
        </mat-paginator>
    </div>
</div>